import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware, combineReducers } from 'redux';
import ReduxThunk from 'redux-thunk';
import { CookiesProvider } from 'react-cookie';
import { reducers } from './reducers';
import App from './App';
import reportWebVitals from './reportWebVitals';

const store = createStore(combineReducers(reducers), {}, applyMiddleware(ReduxThunk));

ReactDOM.render(
    <React.StrictMode>
        <CookiesProvider>
            <App store={store} />
        </CookiesProvider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
